<template>
  <div id="ms_header_downside" class="parent_div">
    <div id="header_main" class="wrapper">
      <div id="menu_area" v-show="isMenuView">
        <div class="toggle" @click="onMenu()" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false"> <span></span> <span></span> <span></span></div>
      </div>
      <div id="haseko_logo" v-if="isHaseko">
        <img :src="this.getImage('common/logo_rashiku.webp')" @click="onLogo()"/>
      </div>
      <div id="logo" v-else>
        <div class="small_text bold" v-if="!isHaseko">サイズオーダー収納専門</div>
        <img :src="this.getImage('common/logo.png')" @click="onLogo()"/>
      </div>
      <div v-show="false"></div>
      <div v-if="isHaseko" id="haseko_price_msg">
        <div class="profit_disp" v-if="isLogin && isDcPriceDisp">mm/styleの販売価格が表示されています。</div>
      </div>
      <div id="hd_payment" v-else>
        <div>全国対応！お値打ち価格でご提供！</div>
        <div class="bold">まずは自動お見積りを！</div>
        <img :src="getImage('bunner/card.webp')">
      </div>
      <div id="space" style="flex-shrink: 1"></div>
      <div v-bind:class="!isHaseko ? {hd_support : true} : {hd_support : true, haseko_hd_support : true}">
        <div v-if="!isHaseko"><img :src="getImage('bunner/icon_call.webp')"></div>
        <div v-if="!isHaseko">
          <div>お電話でのご相談・お問い合わせ受付中！</div>
          <div><a href="tel:0362761123">TEL: 03-6276-1123</a></div>
          <div>月~金曜 10:00～18:00（定休:土日祝）</div>
        </div>
        <div class="hd_corp" v-else>
          <div>長谷工リフォーム オリジナル</div>
          <div>セミオーダー収納家具</div>
        </div>
      </div>
      <div v-bind:class="!isHaseko ? {icon_area : true} : {icon_area : true, haseko_icon_area : true}">
        <div class="hd_icon" @mouseover="isOnSupport=true" @mouseout="isOnSupport=false" v-if="!isHaseko">
          <router-link to="/mmstyle/support/input">
            <img :src="supportImg"/>
            <div v-bind:class="{hd_active: isOnSupport}">お問い合わせ</div>
          </router-link>
        </div>
        <div v-if="isLogin">
          <router-link to="/mmstyle/save/itemlist">
            <img :src="this.getImage('common/save_black.svg')" />
            <div class="small_text bold">保存リスト</div>
          </router-link>
        </div>
        <div>
          <router-link to="/mmstyle/cart">
            <img :src="dispCartImg" />
            <div class="small_text bold">カート</div>
          </router-link>
        </div>
      </div>
    </div>
    <div id="hd_menu" v-if="isMenuBar">
      <div @click="route('DcTop')">トップページ</div>
      <div @click="onRashiku" v-if="isHaseko">RASHIKUについて</div>
      <div @click="route('DcAbout')" v-else>mm/styleについて</div>
      <div @click="routeCategory()">商品を選ぶ</div>
      <div @click="route('DcSketchOrder')" v-if="isSketchOrder">オーダーで作る</div>
      <div @click="route('DcConstructModel')" v-show="false">施工事例</div>
      <div @click="route('DcPaymentGuide')">ご購入ガイド</div>
      <div @click="route('DcCorpInformation')">運営会社案内</div>
      <div class="hd_menu_pickup" @click="route('DcOrderSignIn', {type: 'hd'})" v-if="!isLogin">会員登録/ログイン</div>
      <div class="hd_menu_pickup" @click="route('DcMyPage')" v-else>マイページ</div>
    </div>
    <dd-left-menu
      ref="menuRef"
      v-bind:class="{main_nav: true, active: isMenuActive}"
      @close="close"
    />
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import {mapActions, mapState} from 'vuex'
import DDLeftMenu from '../../components/top/DcLeftMenu'
import {DC_STORAGE_KEY, DC_PRPIC_ON, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../../constants/App'

export default {
  name: 'DcHeader',
  components: {
    'dd-left-menu': DDLeftMenu
  },
  props: {
    headerType: {
      type: Number,
      default: 2
    },
    headerSubContentType: {
      type: Number,
      default: 0
    },
    isDcPriceDisp: {
      type: Boolean,
      default: false
    },
    isMenuView: {
      type: Boolean,
      default: true
    },
    isMenuBar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      user: {},
      imgCreditMufg: this.getImage('order/credit/ECCRD_MUFG.gif'),
      imgCreditDc: this.getImage('order/credit/ECCRD_DC.gif'),
      imgCreditMaster: this.getImage('order/credit/ECCRD_Master.gif'),
      imgCreditNicos: this.getImage('order/credit/ECCRD_NICOS.gif'),
      imgCreditUfj: this.getImage('order/credit/ECCRD_UFJ.gif'),
      imgCreditVisa: this.getImage('order/credit/ECCRD_VISA.gif'),
      isMenuActive: false,
      isOnSupport: false
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    },
    isDispSupport: function () {
      return this.headerTelContentType === 0
    },
    nowList: function () {
      if (!this.cartData || !this.cartData.cartModel || Object.keys(this.cartData.cartModel.orderList).length <= 0) return {}
      return this.cartData.cartModel.orderList
    },
    supportImg: function () {
      if (this.isOnSupport) {
        return this.getImage('common/mail_red.svg')
      } else {
        return this.getImage('common/icon_mail.svg')
      }
    },
    dispCartImg: function () {
      if (!this.nowList.length || this.nowList.length <= 0) {
        return this.getImage('common/cart_red.svg')
      } else {
        return this.getImage('common/cart_red_badge.svg')
      }
    },
    isGuestUser: function () {
      if (!this.user || this.user.userLevel === 4) {
        return true
      }
      return false
    },
    isSketchOrder: function () {
      if (process.env.SKETCH_ORDER !== 1) {
        return false
      }
      return true
    },
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    route: function (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    },
    routeCategory: function (params) {
      if (DC_PRPIC_ON === 1) {
        this.$router.push({
          name: 'DcPrpic',
          query: params
        })
      } else {
        this.$router.push({
          name: 'DcCategory',
          query: params
        })
      }
    },
    onLogo: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    login: function () {
      if (this.isGuestUser) {
        this.$router.push({
          name: 'DcSignUp'
        })
      } else {
        this.$router.push({
          name: 'DcSignIn'
        })
      }
    },
    onMenu: function () {
      this.isMenuActive = true
    },
    close: function () {
      this.isMenuActive = false
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    onRashiku: function () {
      window.open('https://saas.actibookone.com/content/detail?param=eyJjb250ZW50TnVtIjoxNTY1MzV9&detailFlg=1&pNo=1')
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.$store.dispatch('loadCartData', {reload: true})
  }
}
</script>
<style src="../../css/dcheader.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/DcHeader.vue